const Occurrence = () => import('@/modules/occurrence');

export default [
  {
    path: '/ocorrencias/criar',
    component: Occurrence,
    name: 'occurrence-create',
    meta: {
      permissions: ['CREATE_OCCURRENCE',],
      navbarTitle: 'Ajustes em Faturas',
    },
  },
];
